import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useSearchPreferencesStore = defineStore('searchPreferences', () => {
  const selectedEngine = ref('bing')

  const engines = {
    google: {
      name: 'Google',
      url: 'https://www.google.com/search?q=',
      placeholder: 'Search Google...'
    },
    bing: {
      name: 'Bing',
      url: 'https://www.bing.com/search?q=',
      placeholder: 'Search Bing...'
    },
    duckduckgo: {
      name: 'DuckDuckGo',
      url: 'https://duckduckgo.com/?q=',
      placeholder: 'Search DuckDuckGo...'
    }
  }

  const currentEngine = computed(() => engines[selectedEngine.value])
  const searchUrl = computed(() => currentEngine.value.url)

  function setEngine(engine) {
    selectedEngine.value = engine
  }

  return {
    selectedEngine,
    engines,
    currentEngine,
    searchUrl,
    setEngine
  }
}, {
  persist: true
})
